<template>
  <div class="home-list-wrap">
    <div class="tip-more">
      <div class="tip">{{ title }}</div>
      <div
        class="more"
        @click="
          $emit('handleClick', {
            type: 6,
            name: title,
            channelAddress: channelAddress,
          })
        "
      >
        更多
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="home-list-content-wrap">
      <div v-for="(item, index) in data" :key="index">
        <meeting-item
          v-if="item.type == 1"
          :key="index"
          :item="{ ...item, meeting_type: item.meeting_status_des }"
          @item-click="itemMeetingClick(item)"
          :isCredit="true"
        ></meeting-item>
        <consulting-item
          v-else-if="item.type == 4"
          :key="index"
          :item="item"
          @item-click="itemConsultingClick(item)"
        ></consulting-item>
        <div class="includes-video-item" v-else @click="itemAllOther(item)">
          <div class="includes-video-item-title van-multi-ellipsis--l2">
            <span>{{ item.title }}</span>
          </div>
          <div class="includes-video-item-cover">
            <img :src="item.cover" alt />
            <img
              v-if="item.type == 2 || item.type == 3"
              class="play"
              src="@images/player/play_big.svg"
              alt
            />
            <div class="tip" v-if="item.is_operation_review == 1">
              <img src="@images/operation/tip.png" alt="" />
            </div>
          </div>
          <div class="includes-video-item-tip">
            <span class="price" v-if="item.type == 2 && item.price"
              >限时优惠 ￥{{ item.price }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultingItem from '@components/MeetingListItem/ConsultingItem'
import MeetingItem from '@components/MeetingListItem/MeetingItem'
export default {
  props: {
    data: {
      type: Array,
      require: true,
      defalut: []
    },
    title: {

    },
    channelAddress: {}
  },
  components: { ConsultingItem, MeetingItem },
  methods: {
    itemMeetingClick (item) {
      if (item.is_big_meeting == 1) {
        this.$router.push({
          path: '/meetingHome',
          query: {
            meeting_id: item.id
          }
        })
      } else {
        if (item.session_id) {
          this.$router.push({
            path: '/meetingDetail',
            query: {
              meeting_id: item.id,
              schedule_id: item.session_id
            }
          })
        } else {
          this.$router.push({
            path: '/meetingDetail',
            query: {
              meeting_id: item.id
            }
          })
        }
      }
    },
    itemConsultingClick (item) {
      const { information_id } = item
      this.$router.push({
        path: 'homeConsultingDetail',
        query: {
          information_id
        }
      })
    },
    itemAllOther (item) {
      if (item.is_operation_review == 1) {
        this.$router.push({
          path: 'operationDetail',
          query: {
            id: item.id
          }
        })
      } else {
        this.$router.push({
          path: 'doctorSharePage',
          query: {
            production_id: item.id
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@styles/variables.scss";
.home-list-content-wrap {
  padding: 0 3%;
}
.home-list-wrap {
  margin-bottom: 0.43rem;
  .tip-more {
    height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 3% 0rem 3%;
  }
  .tip-more .tip {
    font-size: 0.64rem;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
  }
  .tip-more .more {
    cursor: pointer;
    font-size: 0.51rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
  }
}
::v-deep {
  .meet_list {
    background: #f6f7f9;
    padding-bottom: 0.6rem;
    &:last-child {
      // padding-bottom: 0;
    }
  }
}
.includes-video-item {
  padding: 0.45rem 0 0.21rem 0;
  border-bottom: 1px solid #ececec;
  .includes-video-item-title {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 0.85rem;
    span {
      font-size: 0.64rem;
    }
  }
  .includes-video-item-cover {
    margin-top: 0.21rem;
    width: 100%;
    height: 6.4rem;
    overflow: hidden;
    border-radius: 0.17rem;
    position: relative;
    img {
      width: 100%;
    }
    .play {
      position: absolute;
      left: calc(50% - 0.96rem);
      top: calc(50% - 0.96rem);
      width: 1.92rem;
      height: 1.92rem;
    }
  }
  .includes-video-item-tip {
    margin-top: 0.21rem;
    .time {
      font-size: 0.43rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
    }
    .price {
      font-size: 0.43rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fea602;
    }
  }
}
</style>